import { render, staticRenderFns } from "./SublocationsSelector.vue?vue&type=template&id=3fc26b90&"
import script from "./SublocationsSelector.vue?vue&type=script&lang=js&"
export * from "./SublocationsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports